import {useInjex} from '@injex/react-plugin';
import ReportingSubGroupsManager from "../../managers/reportingSubGroupsManager.mdl";

export default function useReportingSubGroupsManager(): ReportingSubGroupsManager {
    const [inject] = useInjex();
    return inject<ReportingSubGroupsManager>('reportingSubGroupsManager');
}
